import { render, staticRenderFns } from "./animate-x.vue?vue&type=template&id=48c93290&"
import script from "./animate-x.vue?vue&type=script&lang=js&"
export * from "./animate-x.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports